import { PROMOTILE } from '../configs/ApiActionUrl';
import { httpService } from './httpService';
export const promotileService = {
    getAll,
    add,
    edit,
    update,
}

function getAll(){   
    return httpService.get(PROMOTILE.GETALL)
        .then(res => {
            if (res.data) {
                return res.data;
            }
            return res;
        });
}

function add(data){
    return httpService.post(PROMOTILE.ADD, data, {headers: {'Content-Type': 'multipart/form-data'}})
    .then(res => {
        if (res.data) {
            return res.data;
        }
        return res;
    });
}
function edit(id){
    return httpService.get(PROMOTILE.GET_INDIVIDUAL+"/"+id)
        .then(res => {
            if (res.data) {
                return res.data;
            }
            return res;
        });
}
function update(code, data){
    return httpService.put(PROMOTILE.UPDATE_INDIVIDUAL+"/"+code, data, {headers: {'Content-Type': 'multipart/form-data'}})   
    .then(res => {
        if (res.data) {
            return res.data;
        }
        return res;
    });
}